import { render, staticRenderFns } from "./ProviderAuctionTable.vue?vue&type=template&id=62c20262&"
import script from "./ProviderAuctionTable.vue?vue&type=script&lang=js&"
export * from "./ProviderAuctionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports